import { render, staticRenderFns } from "./CounterBaseQuestion.vue?vue&type=template&id=c7addd00&scoped=true&"
import script from "./CounterBaseQuestion.vue?vue&type=script&lang=js&"
export * from "./CounterBaseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CounterBaseQuestion.vue?vue&type=style&index=0&id=c7addd00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7addd00",
  null
  
)

export default component.exports